<template>
  <div id="15_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3">        
        <v-menu
          v-model="PMenuPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="PDate"
              label="Починаючи з:"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="PDate" locale="uk" :first-day-of-week="1" @input="chPDate()"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-menu
        ref="refPTimeMenu"
        v-model="PTimeMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="PTime"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="PTime"
              prepend-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="PTimeMenu"
            v-model="PTime"
            full-width
            format="24hr"
            @click:minute="$refs.refPTimeMenu.save(PTime)"
            @input="getMainTableData()"
          ></v-time-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">        
        <v-menu
          v-model="KMenuPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="KDate"
              label="Закінчуючі:"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="KDate" locale="uk" :first-day-of-week="1" @input="chKDate()"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-menu
        ref="refKTimeMenu"
        v-model="KTimeMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="KTime"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="KTime"
              prepend-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="KTimeMenu"
            v-model="KTime"
            full-width
            format="24hr"
            @click:minute="$refs.refKTimeMenu.save(KTime)"
            @input="getMainTableData()"
          ></v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="getMainTableData()">mdi-update</v-icon>
          </template>
          <span>Поновити таблицю</span>
        </v-tooltip>

        <v-menu>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-file-chart</v-icon>
              </template>
              <span>Звіти</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item @click.stop="dialogGroupTmcOpen()">
              <v-list-item-icon>
                <v-icon>mdi-animation</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Згуртовна продукція</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="dialogZminaOperOpen()">
              <v-list-item-icon>
                <v-icon>mdi-account-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Згуртована продукція (оператор-зміна)</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        
        <v-spacer></v-spacer>
        Виробничі процеси.
        <v-spacer></v-spacer>

        <v-text-field
          v-model="mainTableSearch"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="mainTableHeaders"
        :items="mainTableItems"
        :search="mainTableSearch"
        :items-per-page="20"
        dense
        multi-sort
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="markerPrint(item.sn)">mdi-printer</v-icon>
          <v-icon small class="mr-2" @click.stop="dialogTreeOpen(item)">mdi-file-tree</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="dialogTreeShow"
      scrollable
    >
      <v-card>
        <v-toolbar dense flat dark>
          <v-btn icon dark @click="dialogTreeClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Дерево виробничого процесу</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialogTreeClose()">Закрити</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="min-height: 600px;">
          <v-row>
            <v-col>
              <v-treeview
                :items="dialogTreeSn"
                :load-children="fetchChildInSnTree"
                transition
                hoverable
              >
                <template v-slot:label="{ item }">
                  SN:{{item.id}} <p class="font-weight-bold"> {{item.name}} </p>
                </template>
                <template v-slot:append="{ item }">
                  <v-icon small class="mr-2" @click="dialogTreeZvit1(item)">mdi-table-large</v-icon>
                </template>
              </v-treeview>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col  cols="7">

              Вхідна продукція:
              <v-simple-table dense dark>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">SN</th>
                      <th class="text-left">TMЦ</th>
                      <th class="text-left">Верстат</th>
                      <th class="text-left">Накладна</th>
                      <th class="text-left">Кількість</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itemtop" :key="item.sn">
                      <td>{{ item.sn }}</td>
                      <td>{{ item.nametmc }}</td>
                      <td>{{ item.nameverstat }}</td>
                      <td>{{ item.idn }}</td>
                      <td>{{ item.coundat }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-divider ></v-divider>

              Готова продукція: {{plsList.length}}
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">SN</th>
                      <th class="text-left">TMЦ</th>
                      <th class="text-left">Накладна</th>
                      <th class="text-left">Кількість</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in plsList" :key="item.sn">
                      <td>{{ item.id }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.idn }}</td>
                      <td>{{ item.coundat }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogGroupTmcShow"
      scrollable
    >
      <v-card>
        <v-toolbar dense flat dark>
          <v-btn icon dark @click="dialogGroupTmcClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Згуртовна продукція</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialogGroupTmcClose()">Закрити</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="min-height: 600px;">
          <v-row>
            <v-col>
              <h3>Задіяні у звіті</h3>
              <v-select
                v-model="verstatsSelected"
                :items="verstatsList"
                item-text="nameverstat"
                item-value="idverstat"
                @blur="getZvitGrouMainTableData()"
                label="Верстати"
                multiple
                chips
                persistent-hint
              ></v-select>

              <v-divider></v-divider>

              <v-select
                v-model="operatorSelected"
                :items="operatorList"
                item-text="pip"
                item-value="idoperator"
                @blur="getZvitGrouMainTableData()"
                label="Оператори"
                multiple
                chips
                persistent-hint
              ></v-select>

              
            </v-col>
            <v-divider vertical></v-divider>
            <v-col  cols="7">

              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">article</th>
                      <th class="text-left">TMЦ</th>
                      <th class="text-left">Операцій</th>
                      <th class="text-left">Продукції</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in zvitGrouMainTable" :key="item.name">
                      <td>{{ item.article }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.count }}</td>
                      <td>{{ item.sum }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>


            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogZminaOperShow"
      scrollable
      max-width="1200"
    >
      <v-card>
        <v-toolbar dense flat dark>
          <v-btn icon dark @click="dialogZminaOperClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Згуртовна продукція (оператор-зміна) </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialogZminaOperClose()">Закрити</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="min-height: 600px;">
          <v-row>
            <v-col>
              <h3>Задіяні у звіті</h3>
              <v-select
                v-model="operatorSelected"
                :items="operatorList"
                item-text="pip"
                item-value="idoperator"
                @blur="getZvitOperZminMainTableData()"
                label="Оператори"
                multiple
                chips
                persistent-hint
              ></v-select>

              <v-divider></v-divider>
              <v-col cols="12">
                <h3>Ділимо добу на зміни:</h3>
                <v-radio-group
                  v-model="countZmin"
                  @change="chCountZm()"
                  row
                >
                  <v-radio label="Одна" value="1"></v-radio>
                  <v-radio label="Дві" value="2"></v-radio>
                  <v-radio label="Три" value="3"></v-radio>
                </v-radio-group>
                <h3>{{displayTimeZmin}}</h3>
              </v-col>

              <v-scale-transition>
                <v-col v-if="displayZmin1" cols="12">
                  <v-slider
                    v-model="zmina1"
                    thumb-label
                    ticks="always"
                    min="1"
                    max="24"
                    @change="getZvitOperZminMainTableData()"
                  ></v-slider>
                  <h3>{{displayTimeZmin1}}</h3>
                </v-col>
              </v-scale-transition>

              <v-scale-transition>
                <v-col v-if="displayZmin2" cols="12">
                  <v-slider
                    v-model="zmina2"
                    thumb-label
                    ticks="always"
                    min="1"
                    max="24"
                    @change="getZvitOperZminMainTableData()"
                  ></v-slider>
                  <h3>{{displayTimeZmin2}}</h3>
                </v-col>
              </v-scale-transition>

              
            </v-col>
            <v-divider vertical></v-divider>
            <v-col  cols="8">
              <v-icon x-large  @click="zvitOperZminaPrint()">mdi-printer</v-icon>

              <!-- <v-data-table
                :headers="zvitOperZminaHeaderTable"
                :items="zvitOperZminaItemsTable"
                :items-per-page="15"
                dense
              >
              </v-data-table> -->

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        PDate: '',
        PMenuPicker: false,
        PTime: '00:00',
        PTimeMenu: false,
        KDate: '',
        KMenuPicker: false,
        KTime: '23:59',
        KTimeMenu: false,
        mainTableSearch: '',
        mainTableHeaders: [
          { text: 'SN', value: 'sn', sortable: false },
          { text: 'Верстат' , value: 'nameverstat' },
          { text: 'Час', value: 'prod_time' },
          { text: 'Оператор', value: 'pip' },
          { text: 'ТМЦ', value: 'nametmc' },
          { text: 'В Накладній', value: 'idn' },
          { text: 'Од.Вім.', value: 'nameodvim' },
          { text: 'Кількість', value: 'coundat' },
          { text: '', value: 'actions', sortable: false },
        ],
        mainTableItems: [],
        dialogTreeShow: false,
        dialogTreeSn: [{ id: '', name: '', children: [] },],
        itemtop: [],
        plsList: [],
        dialogGroupTmcShow: false,
        verstatsList: [],
        verstatsSelected: [],
        operatorList: [],
        operatorSelected: [],
        zvitGrouMainTable: [],
        dialogZminaOperShow: false,
        countZmin: '1',
        zmina1: 24,
        zmina2: 24,
        zvitOperZminaHeaderTable: [],
        zvitOperZminaItemsTable: [],
       

        

      }
    },
    watch: {
      zmina1: function (val) {
        if (val > this.zmina2) { this.zmina2 = val }
      },
      zmina2: function (val) {
        if (val < this.zmina1) { this.zmina1 = val }
      },
    },
    methods: {
      getMainTableData () {
        this.progresLineShow = true
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '15',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
            PDate: this.PDate,
            PTime: this.PTime,
            KDate: this.KDate,
            KTime: this.KTime,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then((data) => {
          if (!data.ok) {
            const error = (data && data.message) || data.status
            return Promise.reject(error)
          }
          return data
        })
        .then((data) => data.json())
        .then((data) => {
          if (data.isauth == true) {
            this.mainTableItems = data.tablelist
            this.PDate = data.PDate
            this.KDate = data.KDate
            this.verstatsList = data.verstatlist
            this.operatorList = data.operatorlist
            this.verstatsSelected = []
            this.operatorSelected = []
            this.zvitGrouMainTable = []
            this.progresLineShow = false
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
      },
      getZvitGrouMainTableData () {
        this.progresLineShow = true
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '15',
            ww: '4',
            pp: localStorage.pp,
            pn: localStorage.pn,
            PDate: this.PDate,
            PTime: this.PTime,
            KDate: this.KDate,
            KTime: this.KTime,
            verstatlist: this.verstatsSelected,
            operatorlist: this.operatorSelected,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json()
          if (!response.ok) {
            const error = (data && data.message) || response.status
            return Promise.reject(error)
          }
          if (data.isauth === true) {
            this.zvitGrouMainTable = data.tablelist
            this.progresLineShow = false
          }
          if (data.isauth === false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
      },
      getZvitOperZminMainTableData () {
        // this.progresLineShow = true
        // const requestOptions = {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({
        //     act: '15',
        //     ww: '5',
        //     pp: localStorage.pp,
        //     pn: localStorage.pn,
        //     PDate: this.PDate,
        //     PTime: this.PTime,
        //     KDate: this.KDate,
        //     KTime: this.KTime,
        //     operatorlist: this.operatorSelected,
        //     countZmin: this.countZmin,
        //     zmina1: this.zmina1,
        //     zmina2: this.zmina2,
        //   })
        // };
        // fetch(this.$store.getters.apiUrl, requestOptions)
        // .then(async response => {
        //   const data = await response.json()
        //   if (!response.ok) {
        //     const error = (data && data.message) || response.status
        //     return Promise.reject(error)
        //   }
        //   if (data.isauth === true) {
        //     this.zvitOperZminaHeaderTable = data.tableheaders
        //     this.zvitOperZminaItemsTable = data.tableitems

        //     this.progresLineShow = false
        //   }
        //   if (data.isauth === false) {
        //     this.$router.push('/login').catch(()=>{})
        //   }
        // })
        // .catch(error => {
        //   this.errorMessage = error
        //   this.progresLineShow = false
        //   this.errorAlertShow = true
        // });
      },
      chPDate () {
        this.PMenuPicker = false
        this.getMainTableData()
      },
      chKDate () {
        this.KMenuPicker = false
        this.getMainTableData()
      },
      markerPrint: function (item) {
        window.open(this.$store.getters.apiUrl+"pdf/?ww=marker&sn="+item+"&pp="+localStorage.pp+"&pn="+localStorage.pn, "_blank")
      },
      dialogTreeOpen (item) {
        this.dialogTreeSn = [{ id: item.sn, name: item.nametmc, children: [] },],
        this.dialogTreeShow = true
      },
      dialogTreeClose () {
        this.dialogTreeShow = false
        this.itemtop = []
        this.plsList = []
      },
      dialogTreeZvit1 (item) {
        this.progresLineShow = true
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '15',
            ww: '3',
            pp: localStorage.pp,
            pn: localStorage.pn,
            sn: item.id,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json()
          if (!response.ok) {
            const error = (data && data.message) || response.status
            return Promise.reject(error)
          }
          if (data.isauth == true) {
            this.itemtop = data.itemtop
            this.plsList = data.plsList
            this.progresLineShow = false
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
      },
      async fetchChildInSnTree(item) {
        const requestOptions = await {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '15',
            ww: '2',
            pp: localStorage.pp,
            pn: localStorage.pn,
            sn: item.id,
          })
        }
        return fetch(this.$store.getters.apiUrl, requestOptions)
          .then(res => res.json())
          .then(json => (item.children.push(...json)))
          .catch(err => console.warn(err))
      },
      dialogGroupTmcOpen () {
        this.dialogGroupTmcShow = true
        this.getZvitGrouMainTableData()
      },
      dialogGroupTmcClose () {
        this.dialogGroupTmcShow = false
      },
      dialogZminaOperOpen () {
        this.dialogZminaOperShow = true
      },
      dialogZminaOperClose () {
        this.dialogZminaOperShow = false
      },
      chCountZm() {
        if (this.countZmin == '1' ) {
          this.zmina1 = 24
          this.zmina2 = 24
        }
        if (this.countZmin == '2' ) {
          this.zmina1 = 12
          this.zmina2 = 24
        }
        if (this.countZmin == '3' ) {
          this.zmina1 = 8
          this.zmina2 = 16
        }
        this.getZvitOperZminMainTableData()
      },
      zvitOperZminaPrint() {
        window.open(this.$store.getters.apiUrl+"pdf/?ww=15&pp="+localStorage.pp+"&pn="+localStorage.pn+
        "&opl="+this.operatorSelected+
        "&pd="+this.PDate+
        "&pt="+this.PTime+
        "&kd="+this.KDate+
        "&kt="+this.KTime+
        "&cz="+this.countZmin+
        "&z1="+this.zmina1+
        "&z2="+this.zmina2 , "_blank")
      },

    },
    computed: {
      displayTimeZmin: function () {
        return '00:00-'+this.zmina1+':00'
      },
      displayTimeZmin1: function () {
        return this.zmina1+':00-'+this.zmina2+':00'
      },
      displayTimeZmin2: function () {
        return this.zmina2+':00-24:00'
      },
      displayZmin1: function () {
        if (this.countZmin == '2') {
          return true
        } else if (this.countZmin == '3') {
          return true
        } else {
          return false
        }
      },
      displayZmin2: function () {
        if (this.countZmin == '3') {
          return true
        } else {
          return false
        }
      },
    },
    created: function () {
      this.getMainTableData()

    },
  }
</script>